import NextPage from "./Blog/NextPage/NextPage";
import Blogmain from "./Blog/Blogmain";
import BlogList1 from "./Blog/BlogList/BlogList1";
import SearchResults from "./Blog/BlogList/SearchResults";
// import BlogForm from "./Ebook/Forms/BlogForm";
import { ThemeProvider } from "./Context/ThemeContext";
import { GoogleOAuthProvider } from "@react-oauth/google";
import { ProductProvider } from "./Context/ProductContext";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { DataTransferProvider } from "./DataTransferContext";
import { AuthProvider } from "./Context/AuthContext";
// import { VideoProvider } from "./videoContext/VideoContext";
import { CartProvider } from "./Context/CartContext";
import { SearchProvider } from "./Context/SearchContext.js";
import TrackPageView from "./TrackPageView";
import GlobalSearch from "./GlobalSearch/GlobalSearch.js";

// Blog Footer
import AboutUs from "./FooterMain/AboutUs.js";

import ContactUs from "./FooterMain/ContactUs.js";
import PrivacyPolicy from "./FooterMain/PrivacyPolicy.js";
import RefundPolicy from "./FooterMain/RefundPolicy.js";
import TermAndCondition from "./FooterMain/TermsConditions.js";
import SitemapPage from "./FooterMain/sitemap/Sitemap.js";

function App() {
  return (
    <GoogleOAuthProvider clientId="991105793073-1dikvgcrhdiqahsm2056906unah9tpnb.apps.googleusercontent.com">
      <BrowserRouter>
        <AuthProvider>
          <ProductProvider>
            <ThemeProvider>
              <DataTransferProvider>
                {/* <VideoProvider> */}
                <CartProvider>
                  <SearchProvider>
                    <TrackPageView />
                    <Routes>
                      <Route
                        path="/search/:query"
                        element={<SearchResults />}
                      />
                      <Route path="/:permalink" element={<BlogList1 />} />
                      <Route path="/:category" element={<NextPage />} />
                      {/* <Route path="/blogform" element={<BlogForm />} /> */}
                      <Route path="/" element={<Blogmain />} />
                      <Route path="/about-us" element={<AboutUs />} />
                      <Route path="/contact-us" element={<ContactUs />} />
                      <Route
                        path="/privacy-policy"
                        element={<PrivacyPolicy />}
                      />
                      <Route path="/refund-policy" element={<RefundPolicy />} />
                      <Route
                        path="/terms-and-condition"
                        element={<TermAndCondition />}
                      />
                      <Route path="/sitemap" element={<SitemapPage />} />
                      <Route path="/global-search" element={<GlobalSearch />} />
                    </Routes>
                    {/* <Footer /> */}
                  </SearchProvider>
                </CartProvider>
                {/* </VideoProvider> */}
              </DataTransferProvider>
            </ThemeProvider>
          </ProductProvider>
        </AuthProvider>
      </BrowserRouter>
    </GoogleOAuthProvider>
  );
}

export default App;
